import { Injectable } from '@angular/core';
import { JoyrideService } from 'ngx-joyride';

const STORAGE_KEY_PREFIX = 'promoflo_onboarding_';

@Injectable({ providedIn: 'root' })
export class OnboardingService {

  constructor(private joyrideService: JoyrideService) {}

  hasCompleted(tourId: string): boolean {
    return localStorage.getItem(STORAGE_KEY_PREFIX + tourId) === 'true';
  }

  resetTour(tourId: string): void {
    localStorage.removeItem(STORAGE_KEY_PREFIX + tourId);
  }

  private markCompleted(tourId: string): void {
    localStorage.setItem(STORAGE_KEY_PREFIX + tourId, 'true');
  }

  /** Starts the tour if it hasn't been completed or dismissed before. Safe to call on every page load. */
  startIfNotSeen(tourId: string, steps: string[]): void {
    if (this.hasCompleted(tourId) || this.joyrideService.isTourInProgress()) {
      return;
    }
    this.start(tourId, steps);
  }

  /** Starts the tour regardless of prior completion, e.g. from a manual "Take a tour" button. */
  start(tourId: string, steps: string[]): void {
    if (this.joyrideService.isTourInProgress()) {
      return;
    }
    this.joyrideService.startTour({
      steps,
      showPrevButton: true,
      themeColor: '#2196F3',
      waitingTime: 250
    }).subscribe({
      complete: () => this.markCompleted(tourId)
    });
  }
}
